<script setup lang="ts">
  import { ref } from 'vue';
  import ModalDesktop from './ModalDesktop.vue';
  import { BottomSheet } from '@/components';

  interface ModalProps {
    size?: string;
    title?: string;
    closable?: boolean;
    overlayClosable?: boolean;
    swipeClosable?: boolean;
    zIndex?: number;
    fullSize?: boolean;
    mobile?: boolean;
    contentClass?: string;
    rootClass?: string;
  }

  interface ModalEmits {
    (e: 'close'): void;
  }

  withDefaults(defineProps<ModalProps>(), {
    size: '',
    title: '',
    closable: false,
    overlayClosable: true,
    swipeClosable: true,
    zIndex: 5,
    fullSize: false,
    mobile: false,
    contentClass: '',
    rootClass: '',
  });

  const emit = defineEmits<ModalEmits>();

  const bottomSheetRef = ref<typeof BottomSheet | null>(null);
  const modalDesktopRef = ref<typeof ModalDesktop | null>(null);

  const resetScroll = () => {
    if (bottomSheetRef.value) {
      bottomSheetRef.value.resetScroll();
    }

    if (modalDesktopRef.value) {
      modalDesktopRef.value.resetScroll();
    }
  };

  defineExpose({
    resetScroll,
  });
</script>

<template>
  <BottomSheet
    v-if="mobile"
    ref="bottomSheetRef"
    :height="size"
    :title="title"
    :overlay-closable="overlayClosable"
    :swipe-closable="swipeClosable"
    :z-index="zIndex"
    :content-class="contentClass"
    :root-class="rootClass"
    @close="emit('close')"
  >
    <template #header>
      <slot name="header" />
    </template>
    <slot />
    <template #footer>
      <slot name="footer" />
    </template>
  </BottomSheet>
  <ModalDesktop
    v-else
    ref="modalDesktopRef"
    :width="size"
    :title="title"
    :closable="closable"
    :overlay-closable="overlayClosable"
    :z-index="zIndex"
    :full-size="fullSize"
    :content-class="contentClass"
    :root-class="rootClass"
    @close="emit('close')"
  >
    <template #header>
      <slot name="header" />
    </template>
    <slot />
    <template #footer>
      <slot name="footer" />
    </template>
  </ModalDesktop>
</template>
